import { useState, useContext, useRef } from 'react'
import emailjs from '@emailjs/browser';

import { ContactSection } from "../styled/sections/Contact.styled";

import { LanguageContext } from "../containers/Language";

export default function Contact() {
  const [mailData, setMailData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  })
  const [isMailSent, setIsMailSent] = useState(false)
  const [isMailError, setIsMailError] = useState(false)
  const [isMailFormIncorrect, setIsMailFormIncorrect] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const contactForm = useRef();

  const { dictionary } = useContext(LanguageContext)

  const checkFormData = () => {
    let allInputsFilled = true 
    Object.values(mailData).map(input => {
      if (input.length === 0) allInputsFilled = false
    })

    return allInputsFilled
  }

  const sendEmail = (e) => {
    e.preventDefault();

    if (!checkFormData()) {
      console.log('FAILED... Please set all data');
      setIsSubmitted(true)
      setIsMailFormIncorrect(true)

      setTimeout(() => {
        setIsSubmitted(false)
        setIsMailFormIncorrect(false)
      }, 10000)

      return;
    }

    emailjs
      .sendForm('service_him7khn', 'template_36i6nfl', contactForm.current, {
        publicKey: 'OCLOgdqiOhqx9gNxh',
      })
      .then(
        () => {
          console.log('SUCCESS!');
          setIsSubmitted(true)
          setIsMailSent(true)

          setTimeout(() => {
            setIsSubmitted(false)
            setIsMailSent(false)
          }, 5000)
        },
        (error) => {
          console.log('FAILED...', error.text);
          setIsSubmitted(true)
          setIsMailError(true)

          setTimeout(() => {
            setIsSubmitted(false)
            setIsMailError(false)
          }, 10000)
        },
      );
  }

  return (
    <ContactSection id="section-contact" className={`section-contact ${isSubmitted ? 'reduced' : ''}`}>
      <span className="pretitle">{dictionary.contact.subtitle}</span>
      <h2>{dictionary.contact.sectionTitle}</h2>
      <p>{dictionary.contact.desc}</p>
      <form ref={contactForm} onSubmit={sendEmail} id="contactform">
        <div id="form__name" className="half input__container">
            <input className="input" type="text" name="name" onInput={(e) => setMailData({...mailData, name: e.target.value})} placeholder={dictionary.contact.placeholders.name} autoComplete="off" />
        </div>
        <div id="form__email" className="half input__container">
            <input className="input" type="email" name="email" onInput={(e) => setMailData({...mailData, email: e.target.value})} placeholder={dictionary.contact.placeholders.email} autoComplete="off" />
        </div>
        <div id="form__subject" className="input__container">
            <input className="input" type="text" name="subject" onInput={(e) => setMailData({...mailData, subject: e.target.value})} placeholder={dictionary.contact.placeholders.subject} autoComplete="off" />
        </div>
        <div id="form__message" className="input__container">
        <textarea className="input" rows="8" name="message" onInput={(e) => setMailData({...mailData, message: e.target.value})} placeholder={dictionary.contact.placeholders.message} autoComplete="off"></textarea>
        </div>
        <div id="form__submit" className="input__container">
            <div className={`formnotice success ${isMailSent ? '' : 'hide'}`}>{dictionary.contact.success}</div>
            <div className={`formnotice error ${isMailError ? '' : 'hide'}`}>{dictionary.contact.error}</div>
            <div className={`formnotice incorrect ${isMailFormIncorrect ? '' : 'hide'}`}>{dictionary.contact.incorrect}</div>
            <input id="submit" type="submit" value={dictionary.contact.submit} />
        </div>
      </form>
    </ContactSection>
  );
}
